function createProxy(target, handler) {
  return process.env.NODE_ENV === "development" && (typeof target != "object" || !target) && console.warn(
    "Invalid object given for proxy:",
    target,
    `
  
  This can be due to a missing theme or configuration given to Tamagui.`,
    new Error().stack
  ), new Proxy(target || {}, handler);
}
export {
  createProxy
};
